import { atom } from "recoil";

export const selectedValueConfigState = atom({
  key: "selectedValueConfigState",
  default: [],
});
